import { Box, Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import React from "react";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import ScrollTop from "./ScrollTop";

function CustomerSupport({ classes }) {
  return (
    <Grid container style={{ minHeight: "100vh", padding: "15px 50px" }}>
      <Grid item style={{ textAlign: "justify", margin: "0 auto" }}>
        <Box mt={4} mb={2}>
          <Typography variant="h5" gutterBottom style={{ fontFamily: "Poppins, sans-serif" }}>
            Customer Feedback & Support
          </Typography>
        </Box>

        <Typography variant="body2" paragraph className={classes.greyText}>
          It is NecessaryDevil’s policy and responsibility to provide excellent
          service to its customers. Customer feedback helps us measure whether
          our services are meeting public needs and expectations. It also helps
          us identify problems that need to be solved. High quality customer
          service depends on customer feedback. While praise is always welcome,
          constructive criticism is truly helpful in the long run.
        </Typography>

        <Typography variant="body2" paragraph className={classes.greyText}>
          The policy strives to treat every interaction with the public as an
          opportunity to produce a satisfied customer, or at least one who feels
          that he or she was listened to and taken seriously, even if it was not
          possible to meet his or her request.
        </Typography>

        <Typography variant="body2" paragraph className={classes.greyText}>
          Customer feedback comes to the NecessaryDevil in many ways. The
          requests for service and questions come to NecessaryDevil through a
          customer visit, call, email, post-event survey, messaging on our
          social media sites etc. We try to address all the queries within 48
          working hours of their logging with us.
        </Typography>

        <Typography variant="body2" paragraph className={classes.greyText}>
          Our customer support e mail id being:{" "}
          <strong>necessarydevil@interfaceinfosoft.com</strong>
          <br />
          Our customers can also reach on WhatsApp at:{" "}
          <strong>8378973398</strong>
        </Typography>

        <Box mt={4}>
          <Typography variant="subtitle1" gutterBottom>
            The policy is not intended to cover:
          </Typography>
          <ul style={{ paddingLeft: 24, marginTop: 0 }}>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Complaints about the performance of specific employees, which
                are handled by the NecessaryDevil management.
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Claims for cancellation & refund which come under our
                ‘Cancellation & Refund policy”.
              </Typography>
            </li>
          </ul>
        </Box>
      </Grid>
      <ScrollTop />
    </Grid>
  );
}

const styles = (theme) => ({
  greyText: {
    color: "#616161",
    fontFamily: "Poppins, sans-serif",
  },
});

export default compose(withStyles(styles), withRouter)(CustomerSupport);
